//注册登录
export const MyZhugeTrackGoLgpage=(eventAttrObj)=>{//进入登录页面
    if(window.zhuge){
        zhuge.track("进入登录页面");
    }
}

export const MyZhugeTrackCkLogin=(eventAttrObj)=>{//点击登录
    if(window.zhuge){
        zhuge.track("登录页-点击登录",eventAttrObj);
    }
}

export const MyZhugeTrackLgSuccess=(eventAttrObj)=>{//登录成功
    if(window.zhuge){
        zhuge.track("登录成功");
    }
}

export const MyZhugeTrackLgFailed=(eventAttrObj)=>{//登录失败
    if(window.zhuge){
        zhuge.track("登录失败",eventAttrObj);
    }
}

export const MyZhugeTrackCkReg=(eventAttrObj)=>{//登录失败
    if(window.zhuge){
        zhuge.track("登录页-点击注册",eventAttrObj);
    }
}

export const MyZhugeTrackCkRightNowReg=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("登录页-点击立即注册",eventAttrObj);
    }
}

export const MyZhugeTrackCkRegSuccess=(eventAttrObj)=>{//注册成功
    if(window.zhuge){
        zhuge.track("注册成功");
    }
}

export const MyZhugeTrackCkRegFailed=(eventAttrObj)=>{//注册失败
    if(window.zhuge){
        zhuge.track("注册失败",eventAttrObj);
    }
}


//试用申请流程
export const MyZhugeTrackGoProcess=(eventAttrObj)=>{//进入试用申请流程页
    if(window.zhuge){
        zhuge.track("试用中心-进入试用申请页",eventAttrObj);
    }
}

export const MyZhugeTrackChApplyType=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-点击切换申请类型",eventAttrObj);
    }
}

export const MyZhugeTrackCpCallName=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写昵称",eventAttrObj);
    }
}

export const MyZhugeTrackCpRealName=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写真实姓名",eventAttrObj);
    }
}

export const MyZhugeTrackCpEmail=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写电子邮箱",eventAttrObj);
    }
}

export const MyZhugeTrackCpRegin=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写所在地区",eventAttrObj);
    }
}

export const MyZhugeTrackCpDeTailRegin=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写详细地址",eventAttrObj);
    }
}

export const MyZhugeTrackCpCompany=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写所属公司",eventAttrObj);
    }
}

export const MyZhugeTrackCpSchool=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写所在学校",eventAttrObj);
    }
}

export const MyZhugeTrackCpDepartment=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写所在部门",eventAttrObj);
    }
}

export const MyZhugeTrackCpPosition=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写担任职位",eventAttrObj);
    }
}

export const MyZhugeTrackCpSpecial=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-填写专业",eventAttrObj);
    }
}

export const MyZhugeTrackCkSubmit=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请页-点击提交",eventAttrObj);
    }
}

export const MyZhugeTrackSubmitSUCCESS=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请-提交成功",eventAttrObj);
    }
}

export const MyZhugeTrackSubmitFAILED=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用申请-提交失败",eventAttrObj);
    }
}



export const MyZhugeTrackLoAndReg=(eventName,eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("试用中心页-点击注册/登录");
    }
}

export const MyZhugeTrackFreeTrial=(eventAttrObj)=>{//免费试用
    if(window.zhuge){
        zhuge.track("试用中心页-点击免费试用",eventAttrObj);
    }
}

export const MyZhugeTrackClickSearch=(eventAttrObj)=>{//试用中心搜索
    if(window.zhuge){
        zhuge.track("试用中心页-点击搜索",eventAttrObj);
    }
}

export const MyZhugeTrackGoproDetail=(eventAttrObj)=>{//试用中心进入产品详情页
    if(window.zhuge){
        zhuge.track("试用中心-进入产品详情页",eventAttrObj);
    }
}

export const MyZhugeTrackSearchGoproDetail=(eventAttrObj)=>{//试用中心进入产品详情页,带搜索
    if(window.zhuge){
        zhuge.track("试用中心页-点击产品详情",eventAttrObj);
    }
}

export const MyZhugeTrackClickDownload=(eventAttrObj)=>{//软件下载
    if(window.zhuge){
        zhuge.track("试用中心-产品详情页-点击下载",eventAttrObj);
    }
}

export const MyZhugeTrackClickVideo=(eventAttrObj)=>{//学习视频
    if(window.zhuge){
        zhuge.track("试用中心-产品详情页-点击学习视频",eventAttrObj);
    }
}

export const MyZhugeTrackUserManual=(eventAttrObj)=>{//用户手册
    if(window.zhuge){
        zhuge.track("试用中心-产品详情页-点击用户手册",eventAttrObj);
    }
}

export const MyZhugeTrackViewTime=(eventAttrObj)=>{//用户手册
    if(window.zhuge){
        zhuge.track("试用中心-产品详情页停留时长",eventAttrObj);
    }
}


//企业管理员 授权管理
export const MyZhugeTrackGoManagePage=(eventAttrObj)=>{//进入到管理授权页面
    if(window.zhuge){
        zhuge.track("进入授权管理页",eventAttrObj);
    }
}

export const MyZhugeTrackClickManPower=(eventAttrObj)=>{//账号点击管理授权
    if(window.zhuge){
        zhuge.track("账号点击管理授权",eventAttrObj);
    }
}

export const MyZhugeTrackGrantSN=(eventAttrObj)=>{//分配授权
    if(window.zhuge){
        zhuge.track("授权管理-管理页面点击分配授权",eventAttrObj);
    }
}

export const MyZhugeTrackCancleGrantSN=(eventAttrObj)=>{//取消分配授权
    if(window.zhuge){
        zhuge.track("授权管理-管理页面点击取消分配",eventAttrObj);
    }
}


//成员管理埋点
export const MyZhugeTrackGoMember=(eventAttrObj)=>{//进入成员管理页
    if(window.zhuge){
        zhuge.track("进入成员管理页");
    }
}

export const MyZhugeTrackCkAddBtutton=(eventAttrObj)=>{//点击邀请成员
    if(window.zhuge){
        zhuge.track("部门/成员管理页-点击邀请成员",eventAttrObj);
    }
}

export const MyZhugeTrackCkSeeInviteHis=(eventAttrObj)=>{//查看邀请记录
    if(window.zhuge){
        zhuge.track("成员管理页-点击查看邀请记录");
    }
}

export const MyZhugeTrackCkDLTemplate=(eventAttrObj)=>{//点击下载模板
    if(window.zhuge){
        zhuge.track("邀请成员页-点击下载模板");
    }
}


export const MyZhugeTrackCkCVTemplate=(eventAttrObj)=>{//点击粘贴模板
    if(window.zhuge){
        zhuge.track("邀请成员页-点击粘贴模板");
    }
}

export const MyZhugeTrackCkAddConfirm=(eventAttrObj)=>{//点击粘贴模板
    if(window.zhuge){
        zhuge.track("邀请成员页-点击确定");
    }
}

export const MyZhugeTrackGoPKPMCloud=(eventAttrObj)=>{//进入PKPM云盘
    if(window.zhuge){
        zhuge.track("进入PKPM云盘");
    }
}

export const MyZhugeTrackSeePKPMfile=(eventAttrObj)=>{//点击查看文件
    if(window.zhuge){
        zhuge.track("PKPM云盘-点击查看文件");
    }
}

export const MyZhugeTrackCKexpand=(eventAttrObj)=>{//点击立即扩容
    if(window.zhuge){
        zhuge.track("PKPM云盘-点击立即扩容");
    }
}

export const MyZhugeTrackCKDKflie=(eventAttrObj)=>{//点击下载
    if(window.zhuge){
        zhuge.track("PKPM云盘-点击下载");
    }
}

export const MyZhugeTrackCKuploadflie=(eventAttrObj)=>{//点击上传
    if(window.zhuge){
        zhuge.track("PKPM云盘-点击上传");
    }
}

export const MyZhugeTrackCKshareflie=(eventAttrObj)=>{//点击分享
    if(window.zhuge){
        zhuge.track("PKPM云盘-点击分享");
    }
}

export const MyZhugeTrackDeleteflie=(eventAttrObj)=>{//点击删除
    if(window.zhuge){
        zhuge.track("PKPM云盘-点击删除");
    }
}

export const MyZhugeTrackCKBuySearch=(eventAttrObj)=>{//点击删除
    if(window.zhuge){
        zhuge.track("线上购买页-点击搜索",eventAttrObj);
    }
}

export const MyZhugeTrackCKBuySomeGoods=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买页-点选某产品",eventAttrObj);
    }
}

export const MyZhugeTrackCKBuyDetailBuyNow=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买-产品详情页-点击立即购买",eventAttrObj);
    }
}

export const MyZhugeTrackCKBuyCKNext=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买-…-点击立即购买-下一步",eventAttrObj);
    }
}

export const MyZhugeTrackBuyCKSubmitOrder=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买-…-下一步-提交订单",eventAttrObj);
    }
}

export const MyZhugeTrackBuyPaySuccess=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买-…-提交订单-支付成功",eventAttrObj);
    }
}

export const MyZhugeTrackBuyDLCkProductIntro=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买-产品详情页-产品介绍",eventAttrObj);
    }
}

export const MyZhugeTrackBuyDLCkDownload=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买-产品详情页-使用下载",eventAttrObj);
    }
}

export const MyZhugeTrackBuyDLCkLearnVideo=(eventAttrObj)=>{
    if(window.zhuge){
        zhuge.track("线上购买-产品详情页-学习视频",eventAttrObj);
    }
}

export const MyZhugeTrackDepMgMoveMember=(eventAttrObj)=>{//部门成员管理-移动成员
    if(window.zhuge){
        zhuge.track("部门/成员管理页-点击移动成员",eventAttrObj);
    }
}

export const MyZhugeTrackDepMgDeleteMember=(eventAttrObj)=>{//部门成员管理-移动成员
    if(window.zhuge){
        zhuge.track("部门/成员管理页-点击删除成员",eventAttrObj);
    }
}

export const MyZhugeTrackDepMgMemberApply=(eventAttrObj)=>{//部门成员管理-成员申请
    if(window.zhuge){
        zhuge.track("部门/成员管理页-点击成员申请",eventAttrObj);
    }
}

export const MyZhugeTrackLimitsMgAddGroup=(eventAttrObj)=>{//部门成员管理-成员申请
    if(window.zhuge){
        zhuge.track("权限管理-点击添加管理组",eventAttrObj);
    }
}

export const MyZhugeTrackPowerMgCKDepAllocateBtn=(eventAttrObj)=>{//授权管理-点击部门授权分拨
    if(window.zhuge){
        zhuge.track("授权管理-点击部门授权分拨");
    }
}

export const MyZhugeTrackPowerMgCKfenbo=(eventAttrObj)=>{//授权管理-部门授权分拨-点击分拨
    if(window.zhuge){
        zhuge.track("授权管理-部门授权分拨-点击分拨");
    }
}

export const MyZhugeTrackPowerMgCKhuishou=(eventAttrObj)=>{//授权管理-部门授权分拨-点击回收
    if(window.zhuge){
        zhuge.track("授权管理-部门授权分拨-点击回收");
    }
}

export const MyZhugeTrackPowerMghuishouSUCCESS=(eventAttrObj)=>{//授权管理-部门授权分拨-点击回收-回收成功
    if(window.zhuge){
        zhuge.track("授权管理-部门授权分拨-点击回收-回收成功");
    }
}

export const MyZhugeTrackPowerMgfenboSUCCESS=(eventAttrObj)=>{//授权管理-部门授权分拨-点击分拨-分拨成功
    if(window.zhuge){
        zhuge.track("授权管理-部门授权分拨-点击分拨-分拨成功");
    }
}


// WEBPACK FOOTER //
// ./src/js/zhugemaidian.js